// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	Address: 'address',
	AddressForm: 'address-form',
	EditAddressButton: 'edit-address-button',
	Card: 'card',
} as const;
